/* unplugin-vue-components disabled */import { render } from "./SmartCourse.vue?vue&type=template&id=d493bc38&scoped=true"
import script from "./SmartCourse.vue?vue&type=script&lang=js"
export * from "./SmartCourse.vue?vue&type=script&lang=js"

import "./SmartCourse.vue?vue&type=style&index=0&id=d493bc38&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户山农大-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d493bc38"]])

export default __exports__